var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, EventEmitter, Input, Output, ViewChild, HostListener } from '@angular/core';
import * as go from '../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { ConfigureConsts } from '../../../../shared/configure-consts';
import { HistoryCurveSettingComponent } from '../../element-setting/history-curve/history-curve-setting.component';
import { RingGraphGeneralDataToGoModelUtil } from '../../element-setting/ring-graph/general/ring-graph-general-data-to-go-model-util';
import { RingGraphGeneralGoModelToDataConverter } from '../../element-setting/ring-graph/general/ring-graph-general-go-model-to-data-converter';
import { RingGraphSettingComponent } from '../../element-setting/ring-graph/ring-graph-setting.component';
import { CalibrationDataToGoModelUtil } from '../../element-setting/shared/calibration-mark/calibration-data-to-go-model-util';
import { CalibrationGoModelToDataUtil } from '../../element-setting/shared/calibration-mark/calibration-go-model-to-data-util';
import { ExtendPropertyDataToGoModelUtil } from '../../element-setting/shared/extend-property/extend-property-data-to-go-model-util';
import { ExtendPropertyAdapter } from '../../element-setting/shared/extend-property/extend-property.adapter';
import { DiagramConsts } from '../../diagram/diagram-consts';
import { ConfigureView } from '../shared/configure-view';
import { ConfigureViewType } from '../shared/configure-view-type';
import { StraightLineGeneralGoModelToDataConverter } from '../../element-setting/straight-line/general/straight-line-general-go-model-to-data-converter';
import { StraightLineSettingComponent } from '../../element-setting/straight-line/straight-line-setting.component';
import { StraightLineGeneralDataToGoModelUtil } from '../../element-setting/straight-line/general/straight-line-general-data-to-go-model-util';
import { PolyLineGeneralGoModelToDataConverter } from '../../element-setting/poly-line/general/poly-line-general-go-model-to-data-converter';
import { PolyLineSettingComponent } from '../../element-setting/poly-line/poly-line-setting.component';
import { PolyLineGeneralDataToGoModelUtil } from '../../element-setting/poly-line/general/poly-line-general-data-to-go-model-util';
import { PolygonGeneralGoModelToDataConverter } from '../../element-setting/polygon/general/polygon-general-go-model-to-data-converter';
import { PolygonSettingComponent } from '../../element-setting/polygon/polygon-setting.component';
import { PolygonGeneralDataToGoModelUtil } from '../../element-setting/polygon/general/polygon-general-data-to-go-model-util';
import { VideoSettingComponent } from '../../element-setting/video/video-setting.component';
import { TableSettingComponent } from '../../element-setting/table/table-setting.component';
import { TableGeneralGoModelToDataConverter } from '../../element-setting/table/general/table-general-go-model-to-data-converter';
import { TableGeneralDataToGoModelUtil } from '../../element-setting/table/general/table-general-data-to-go-model-util';
import { DesignerConsts } from '../shared/designer-consts';
import { UpdateConfigureViewDto, UpdateConfigureDto } from '../../../../shared/service-proxies/service-proxies';
var ConfigureViewTabComponent = /** @class */ (function (_super) {
    __extends(ConfigureViewTabComponent, _super);
    function ConfigureViewTabComponent(injector, configureService, configureViewService, modalService, cdr) {
        var _this = _super.call(this, injector) || this;
        _this.configureService = configureService;
        _this.configureViewService = configureViewService;
        _this.modalService = modalService;
        _this.cdr = cdr;
        _this.updateConfigureViews = [];
        _this.views = new Array();
        _this._configureViewArgs = new Array();
        _this.viewChanged = new EventEmitter();
        _this.responseContentView = new EventEmitter();
        _this.configureViewTitleMoveDistance = 0;
        _this.customWaringName = '';
        _this.openCallback = function (args) { return _this.openView(args); };
        _this.deleteCallback = function (view) { return _this.deleteView(view); };
        _this.updateWebMainViewIdCallback = function (viewId) { return _this.webMainViewId = viewId; };
        _this.updateMobileMainViewIdCallback = function (viewId) { return _this.mobileMainViewId = viewId; };
        _this.saveCallback = function (callback) { return _this.saveAll(callback); };
        _this.refreshConfigureViewCallback = function () { return _this.refreshConfigureView(); };
        return _this;
    }
    ConfigureViewTabComponent.prototype.getConfigureViewArg = function (view) {
        var viewArg = this._configureViewArgs.find(function (r) { return r.viewId === view.id; });
        if (viewArg) {
            viewArg.diagramModel = view.configure;
            return viewArg;
        }
        viewArg = {
            viewId: view.id,
            diagramModel: view.configure,
            modified: view.modified,
            width: view.width,
            height: view.height,
            type: view.type,
            configureId: this.configureId,
            showSettingsWhenInited: view.showSettingsWhenInited,
            name: view.name
        };
        this._configureViewArgs.push(viewArg);
        return viewArg;
    };
    ConfigureViewTabComponent.prototype.ngOnInit = function () {
        abp.event.on('designer:open-view', this.openCallback);
        abp.event.on('designer:delete-view', this.deleteCallback);
        abp.event.on('designer:update-webMainViewId', this.updateWebMainViewIdCallback);
        abp.event.on('designer:update-mobileMainViewId', this.updateMobileMainViewIdCallback);
        abp.event.on('designer:save', this.saveCallback);
        abp.event.on('designer:refresh-configureView', this.refreshConfigureViewCallback);
    };
    ConfigureViewTabComponent.prototype.ngOnDestroy = function () {
        abp.event.off('designer:open-view', this.openCallback);
        abp.event.off('designer:delete-view', this.deleteCallback);
        abp.event.off('designer:update-webMainViewId', this.updateWebMainViewIdCallback);
        abp.event.off('designer:update-mobileMainViewId', this.updateMobileMainViewIdCallback);
        abp.event.off('designer:save', this.saveCallback);
        abp.event.off('designer:refresh-configureView', this.refreshConfigureViewCallback);
    };
    ConfigureViewTabComponent.prototype.responseViewTabActive = function () {
        this.responseContentView.emit();
    };
    ConfigureViewTabComponent.prototype.saveDataProperty = function (model, propertyName, value) {
        this.currentDiagram.model.setDataProperty(model, propertyName, value);
    };
    ConfigureViewTabComponent.prototype.elementDoubleClicked = function (arg) {
        var currentEditedComponent = arg.subject.panel.part;
        switch (currentEditedComponent.category) {
            case DiagramConsts.elements.numericalDisplayKey:
                this.numericalDisplaySettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.imageKey:
                this.imageSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.textKey:
                this.textModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.hyperlinkKey:
                this.hyperlinkModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.switchIndicatorLightKey:
                this.switchIndicatorLightSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.pipeKey:
                this.pipeModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.meterKey:
                this.meterSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.barGraphKey:
                this.barGraphSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.toggleViewKey:
                this.toggleViewSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.characterKey:
                this.characterDisplaySettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.rectangleKey:
                this.rectangleSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.ellipseKey:
                this.ellipseSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.sectorKey:
                this.sectorSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.dateTimeKey:
                this.dateTimeSettingModal.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.weatherKey:
                this.weatherModalComponent.show({
                    configureId: this.configureId,
                    model: currentEditedComponent
                });
                break;
            case DiagramConsts.elements.historyCurveKey: {
                this.openHistoryCurveModal(currentEditedComponent);
                break;
            }
            case DiagramConsts.elements.ringGraphKey: {
                this.openRingGraphModal(currentEditedComponent);
                break;
            }
            case DiagramConsts.elements.straightLineKey: {
                this.openStraightLineModal(currentEditedComponent);
                break;
            }
            case DiagramConsts.elements.polyLineKey: {
                this.openPolyLineModal(currentEditedComponent);
                break;
            }
            case DiagramConsts.elements.polygonKey: {
                this.openPolygonModal(currentEditedComponent);
                break;
            }
            case DiagramConsts.elements.videoKey: {
                this.openVideoModal(currentEditedComponent);
                break;
            }
            case DiagramConsts.elements.tableKey: {
                this.openTableModal(currentEditedComponent);
                break;
            }
        }
    };
    ConfigureViewTabComponent.prototype.openVideoModal = function (currentEditedComponent) {
        var _this = this;
        var curveSetting = {
            videoType: _.cloneDeep(currentEditedComponent.data.videoType),
            videoTag: _.cloneDeep(currentEditedComponent.data.videoTag)
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            data: curveSetting
        };
        var modalRef = this.modalService.show(VideoSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'video-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            modalRef.hide();
            if (result) {
                _this.currentDiagram.startTransaction('video settings');
                _this.saveDataProperty(currentEditedComponent.data, 'videoType', result.videoType);
                _this.saveDataProperty(currentEditedComponent.data, 'videoTag', result.videoTag);
                _this.currentDiagram.commitTransaction('video settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.openHistoryCurveModal = function (currentEditedComponent) {
        var _this = this;
        var curveSetting = {
            calibrationMarkSetting: _.cloneDeep(currentEditedComponent.data.calibrationMarkSetting),
            generalSetting: _.cloneDeep(currentEditedComponent.data.generalSetting),
            channelSetting: _.cloneDeep(currentEditedComponent.data.channelSetting),
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            allSettings: curveSetting
        };
        var modalRef = this.modalService.show(HistoryCurveSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'history-curve-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.currentDiagram.startTransaction('history-curve settings');
                _this.saveDataProperty(currentEditedComponent.data, 'calibrationMarkSetting', result.calibrationMarkSetting);
                _this.saveDataProperty(currentEditedComponent.data, 'generalSetting', result.generalSetting);
                _this.saveDataProperty(currentEditedComponent.data, 'channelSetting', result.channelSetting);
                _this.currentDiagram.commitTransaction('history-curve settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.openRingGraphModal = function (currentEditedComponent) {
        var _this = this;
        var ringGraphSetting = {
            generalSetting: new RingGraphGeneralGoModelToDataConverter(currentEditedComponent.data),
            expendSetting: new ExtendPropertyAdapter(currentEditedComponent.data),
            calibrationMarkSetting: new CalibrationGoModelToDataUtil(currentEditedComponent.data).toViewData()
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            allSettings: ringGraphSetting
        };
        var modalRef = this.modalService.show(RingGraphSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'ring-graph-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.currentDiagram.startTransaction('ring-graph settings');
                new RingGraphGeneralDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.generalSetting);
                new CalibrationDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.calibrationMarkSetting);
                new ExtendPropertyDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.expendSetting);
                _this.currentDiagram.commitTransaction('ring-graph settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.openStraightLineModal = function (currentEditedComponent) {
        var _this = this;
        var straightLineSetting = {
            generalSetting: new StraightLineGeneralGoModelToDataConverter(currentEditedComponent.data)
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            allSettings: straightLineSetting,
            viewWidth: this.selectViewWidth,
            viewHeight: this.selectViewHeight
        };
        var modalRef = this.modalService.show(StraightLineSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'straight-line-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.currentDiagram.startTransaction('straight-line settings');
                new StraightLineGeneralDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.generalSetting);
                _this.currentDiagram.commitTransaction('straight-line settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.openPolyLineModal = function (currentEditedComponent) {
        var _this = this;
        var PolyLineSetting = {
            generalSetting: new PolyLineGeneralGoModelToDataConverter(currentEditedComponent.data)
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            allSettings: PolyLineSetting,
            viewWidth: this.selectViewWidth,
            viewHeight: this.selectViewHeight
        };
        var modalRef = this.modalService.show(PolyLineSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'poly-line-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.currentDiagram.startTransaction('poly-line settings');
                new PolyLineGeneralDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.generalSetting);
                _this.currentDiagram.commitTransaction('poly-line settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.openPolygonModal = function (currentEditedComponent) {
        var _this = this;
        var polygonSetting = {
            generalSetting: new PolygonGeneralGoModelToDataConverter(currentEditedComponent.data)
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            allSettings: polygonSetting,
            viewWidth: this.selectViewWidth,
            viewHeight: this.selectViewHeight
        };
        var modalRef = this.modalService.show(PolygonSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'polygon-setting-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.currentDiagram.startTransaction('polygon settings');
                new PolygonGeneralDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.generalSetting);
                _this.currentDiagram.commitTransaction('polygon settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.openTableModal = function (currentEditedComponent) {
        var _this = this;
        var tableSetting = {
            generalSetting: new TableGeneralGoModelToDataConverter(currentEditedComponent.data)
        };
        var arg = {
            configureId: this.configureId,
            model: { model: currentEditedComponent, configureId: this.configureId },
            allSettings: tableSetting,
            viewWidth: this.selectViewWidth,
            viewHeight: this.selectViewHeight
        };
        var modalRef = this.modalService.show(TableSettingComponent, {
            initialState: {
                arg: arg
            },
            backdrop: 'static',
            class: 'table-modal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.currentDiagram.startTransaction('table settings');
                new TableGeneralDataToGoModelUtil(_this.currentDiagram, currentEditedComponent.data)
                    .saveToGoJsModel(result.generalSetting);
                _this.currentDiagram.commitTransaction('table settings');
            }
            onClosedSub.unsubscribe();
        });
    };
    ConfigureViewTabComponent.prototype.selectView = function (viewId, viewType) {
        var _this = this;
        if (this.selectedViewId !== viewId || !this.currentDiagram) {
            this.selectedViewId = viewId;
            this.currentDiagram = this.getDiagram(viewId);
            this.viewChanged.emit({ id: viewId, diagram: this.currentDiagram });
            if (this.currentDiagram && this.currentDiagram.scale) {
                abp.event.trigger(ConfigureConsts.event.zoomChangedEventName, this.currentDiagram.scale);
            }
            setTimeout(function () {
                _this.moveConfigureViewTitleList();
            }, 0);
        }
        abp.event.trigger('designer:configureViewType', viewType);
    };
    ConfigureViewTabComponent.prototype.tryRemoveTabHandler = function (view) {
        var _this = this;
        this.modifyingDiagram = this.getDiagram(view.id);
        this.removingView = view;
        this.name = view.name;
        if (this.modifyingDiagram.isModified) {
            this.leaveWorkshopWarningModal.show();
        }
        else {
            this.removeView(view);
        }
        setTimeout(function () {
            _this.moveConfigureViewTitleList();
        }, 0);
    };
    ConfigureViewTabComponent.prototype.getIconClass = function (view) {
        if (view.type === ConfigureViewType.Web.valueOf()) {
            return view.id === this.webMainViewId ? 'pageTabs-startup-web-icon' : 'pageTabs-default-web-icon';
        }
        else if (view.type === ConfigureViewType.Mobile.valueOf()) {
            return view.id === this.mobileMainViewId ? 'pageTabs-startup-app-icon' : 'pageTabs-default-app-icon';
        }
        else if (view.type === ConfigureViewType.Thumbnail.valueOf()) {
            return 'pageTabs-thumbnail-icon';
        }
        else if (view.type === ConfigureViewType.PopView.valueOf()) {
            return 'popview-thumbnail-icon';
        }
    };
    ConfigureViewTabComponent.prototype.getDiagram = function (id) {
        var element;
        element = document.getElementById('View-' + id);
        return go.Diagram.fromDiv(element);
    };
    ConfigureViewTabComponent.prototype.openView = function (args) {
        var _this = this;
        var item = args.view;
        var viewIndex = _.findIndex(this.views, function (view) { return view.id === item.id; });
        this.selectViewWidth = item.width;
        this.selectViewHeight = item.height;
        if (viewIndex < 0) {
            abp.ui.setBusy();
            this.configureViewService.getViewConfigure(item.id).pipe(finalize(function () { return abp.ui.clearBusy(); }))
                .subscribe(function (result) {
                _.remove(_this._configureViewArgs, function (v) {
                    return v.viewId === item.id;
                });
                _this.views.push(new ConfigureView(item.id, item.name, item.isMainView, result.type.valueOf(), result.width, result.height, result.configure, args.isShowSettings));
                _this.cdr.detectChanges();
                setTimeout(function () { return _this.selectView(item.id, item.type); }, 0);
            });
        }
        else {
            this.selectView(item.id, item.type);
            if (args.isShowSettings) {
                abp.event.trigger('designer:set-view-settings', item);
            }
        }
    };
    ConfigureViewTabComponent.prototype.refreshConfigureView = function () {
        var _this = this;
        var configureViewIds = [];
        this.views.forEach(function (view) {
            configureViewIds.push(view.id);
        });
        if (configureViewIds.length === 0) {
            return;
        }
        this.configureViewService.getViewConfigures(configureViewIds).subscribe(function (r) {
            _.forEach(r.items, function (item) {
                _.forEach(_this.views, function (view) {
                    if (view.id === item.id) {
                        view.configure = item.configure;
                        abp.event.trigger(DesignerConsts.events.modelChanged, item);
                    }
                });
            });
            _this.cdr.detectChanges();
        });
    };
    ConfigureViewTabComponent.prototype.deleteView = function (item) {
        var view = _.find(this.views, function (tabs) { return item.id === tabs.id; });
        if (view) {
            this.removeView(view);
        }
        this.notify.info(this.l('SuccessfullyDeleted'));
    };
    ConfigureViewTabComponent.prototype.removeView = function (view) {
        var index = this.views.indexOf(view);
        if (index < 0) {
            return;
        }
        if (view.id === this.selectedViewId) {
            this.selectedViewId = undefined;
            if (this.hasAvailableTabs(index)) {
                var newActiveIndex = this.getClosestTabIndex(index);
                this.selectedViewId = this.views[newActiveIndex].id;
            }
        }
        this.views.splice(index, 1);
        if (this.modifyingDiagram) {
            this.modifyingDiagram.isModified = false;
        }
    };
    ConfigureViewTabComponent.prototype.saveAll = function (callback) {
        var _this = this;
        abp.ui.setBusy();
        var input = new UpdateConfigureDto;
        input.configureViews = this.getDiagramJsonForViews();
        this.configureService.updateConfigure(input)
            .pipe(finalize(function () {
            if (!callback) {
                abp.ui.clearBusy();
            }
        }))
            .subscribe(function () {
            if (callback) {
                callback();
            }
            else {
                abp.notify.success(_this.l('SuccessfullySaved'));
            }
            abp.event.trigger('designer:saved');
        });
    };
    ConfigureViewTabComponent.prototype.getDiagramJsonForViews = function () {
        var _this = this;
        var updateConfigureViews = new Array();
        _.forEach(this.views, function (view) {
            var updateConfigureView = new UpdateConfigureViewDto();
            updateConfigureView.id = view.id;
            updateConfigureView.configure = _this.getConfigureById(view.id);
            updateConfigureViews.push(updateConfigureView);
        });
        return updateConfigureViews;
    };
    ConfigureViewTabComponent.prototype.getConfigureById = function (id) {
        var diagram = this.getDiagram(id);
        return diagram.model.toJson();
    };
    ConfigureViewTabComponent.prototype.getClosestTabIndex = function (index) {
        var tabsLength = this.views.length;
        if (!tabsLength) {
            return -1;
        }
        for (var step = 1; step <= tabsLength; step += 1) {
            var prevIndex = index - step;
            var nextIndex = index + step;
            if (this.views[prevIndex] && !this.views[prevIndex].disabled) {
                return prevIndex;
            }
            if (this.views[nextIndex] && !this.views[nextIndex].disabled) {
                return nextIndex;
            }
        }
        return -1;
    };
    ConfigureViewTabComponent.prototype.hasAvailableTabs = function (index) {
        var tabsLength = this.views.length;
        if (!tabsLength) {
            return false;
        }
        for (var i = 0; i < tabsLength; i += 1) {
            if (!this.views[i].disabled && i !== index) {
                return true;
            }
        }
        return false;
    };
    ConfigureViewTabComponent.prototype.updateConfigureViewConfigure = function () {
        var _this = this;
        var updateConfigureView = new UpdateConfigureViewDto;
        updateConfigureView.id = this.removingView.id;
        updateConfigureView.configure = this.modifyingDiagram.model.toJson();
        var input = new UpdateConfigureDto;
        input.configureViews = [updateConfigureView];
        abp.ui.setBusy();
        this.configureService.updateConfigure(input).pipe(finalize(function () { return abp.ui.clearBusy(); }))
            .subscribe(function () {
            _this.removeView(_this.removingView);
        });
    };
    ConfigureViewTabComponent.prototype.closeCurrentView = function () {
        var _this = this;
        var view = _.find(this.views, function (tabs) { return _this.selectedViewId === tabs.id; });
        if (!view) {
            return;
        }
        this.tryRemoveTabHandler(view);
    };
    ConfigureViewTabComponent.prototype.closeOtherViews = function () {
        var _this = this;
        this.isCloseOtherViews = true;
        var otherViews = this.views.filter(function (view) {
            return view.id !== _this.selectedViewId;
        });
        if (this.hasModified(otherViews)) {
            this.name = '';
            this.customWaringName = this.lc('SaveClosingView');
            this.leaveWorkshopWarningModal.show();
        }
        else {
            this.unSaveEvent();
            this.configureViewTitleMoveDistance = 0;
        }
    };
    ConfigureViewTabComponent.prototype.closeAllViews = function () {
        this.isCloseAllViews = true;
        if (!this.views || this.views.length <= 0) {
            this.selectedViewId = undefined;
            return;
        }
        if (this.hasModified(this.views)) {
            this.name = '';
            this.customWaringName = this.lc('SaveClosingView');
            this.leaveWorkshopWarningModal.show();
        }
        else {
            this.unSaveEvent();
        }
    };
    ConfigureViewTabComponent.prototype.hasModified = function (views) {
        var _this = this;
        var hasModified = false;
        _.forEach(views, function (otherView) {
            if (_this.getDiagram(otherView.id).isModified) {
                hasModified = true;
            }
        });
        return hasModified;
    };
    ConfigureViewTabComponent.prototype.unSaveEvent = function () {
        var _this = this;
        if (this.isCloseOtherViews) {
            this.views = this.views.filter(function (view) {
                return view.id === _this.selectedViewId;
            });
            this.selectedViewId = this.views[0].id;
            this.isCloseOtherViews = false;
        }
        else if (this.isCloseAllViews) {
            this.views = [];
            this.selectedViewId = undefined;
            this.isCloseAllViews = false;
        }
        else {
            this.removeView(this.removingView);
        }
    };
    ConfigureViewTabComponent.prototype.saveEvent = function () {
        if (this.isCloseOtherViews) {
            this.saveOtherViews();
            this.configureViewTitleMoveDistance = 0;
        }
        else if (this.isCloseAllViews) {
            this.saveAll();
            this.unSaveEvent();
        }
        else {
            this.updateConfigureViewConfigure();
        }
    };
    ConfigureViewTabComponent.prototype.saveOtherViews = function () {
        var _this = this;
        abp.ui.setBusy();
        var input = new UpdateConfigureDto;
        input.configureViews = this.getOtherViews();
        this.configureService.updateConfigure(input).pipe(finalize(function () {
            abp.ui.clearBusy();
        })).subscribe(function () {
            abp.notify.success(_this.l('SuccessfullySaved'));
            var currentView = _this.views.filter(function (view) {
                return view.id === _this.selectedViewId;
            });
            _this.unSaveEvent();
            if (_this.getDiagram(currentView[0].id).isModified) {
                return;
            }
            abp.event.trigger('designer:saved');
        });
    };
    ConfigureViewTabComponent.prototype.getOtherViews = function () {
        var _this = this;
        var otherViews = this.views.filter(function (view) {
            return view.id !== _this.selectedViewId;
        });
        var updateConfigureViews = new Array();
        _.forEach(otherViews, function (view) {
            var updateConfigureView = new UpdateConfigureViewDto();
            updateConfigureView.id = view.id;
            updateConfigureView.configure = _this.getConfigureById(view.id);
            updateConfigureViews.push(updateConfigureView);
        });
        return updateConfigureViews;
    };
    ConfigureViewTabComponent.prototype.moveConfigureViewTitleList = function () {
        var configureViewTitleWindowWidth = this.configureViewTitleWindow.nativeElement ? this.configureViewTitleWindow.nativeElement.offsetWidth : 0;
        var configureViewTitleListWidth = this.configureViewTitleList.nativeElement ? this.configureViewTitleList.nativeElement.offsetWidth : 0;
        var selectedConfigureViewTitleLeft = this.configureViewTitleList.nativeElement
            && this.configureViewTitleList.nativeElement.querySelector('li.active')
            && this.configureViewTitleList.nativeElement.querySelector('li.active').previousSibling
            && this.configureViewTitleList.nativeElement.querySelector('li.active').previousSibling.nodeType === 1
            ? this.configureViewTitleList.nativeElement.querySelector('li.active').previousSibling.offsetLeft : 0;
        if (configureViewTitleListWidth > configureViewTitleWindowWidth) {
            if (selectedConfigureViewTitleLeft > configureViewTitleListWidth - configureViewTitleWindowWidth) {
                this.configureViewTitleMoveDistance = configureViewTitleWindowWidth - configureViewTitleListWidth - 28;
            }
            else {
                this.configureViewTitleMoveDistance = -selectedConfigureViewTitleLeft;
            }
        }
        else {
            this.configureViewTitleMoveDistance = 0;
        }
    };
    __decorate([
        ViewChild('numericalDisplaySettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "numericalDisplaySettingModal", void 0);
    __decorate([
        ViewChild('imageSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "imageSettingModal", void 0);
    __decorate([
        ViewChild('textSettingModalComponent', { static: false })
    ], ConfigureViewTabComponent.prototype, "textModal", void 0);
    __decorate([
        ViewChild('hyperlinkModalComponent', { static: false })
    ], ConfigureViewTabComponent.prototype, "hyperlinkModal", void 0);
    __decorate([
        ViewChild('pipeSettingModalComponent', { static: false })
    ], ConfigureViewTabComponent.prototype, "pipeModal", void 0);
    __decorate([
        ViewChild('meterSettingModalComponent', { static: false })
    ], ConfigureViewTabComponent.prototype, "meterSettingModal", void 0);
    __decorate([
        ViewChild('switchIndicatorLightSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "switchIndicatorLightSettingModal", void 0);
    __decorate([
        ViewChild('barGraphSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "barGraphSettingModal", void 0);
    __decorate([
        ViewChild('toggleViewSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "toggleViewSettingModal", void 0);
    __decorate([
        ViewChild('characterDisplaySettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "characterDisplaySettingModal", void 0);
    __decorate([
        ViewChild('rectangleSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "rectangleSettingModal", void 0);
    __decorate([
        ViewChild('ellipseSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "ellipseSettingModal", void 0);
    __decorate([
        ViewChild('sectorSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "sectorSettingModal", void 0);
    __decorate([
        ViewChild('dateTimeSettingModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "dateTimeSettingModal", void 0);
    __decorate([
        ViewChild('weatherModalComponent', { static: false })
    ], ConfigureViewTabComponent.prototype, "weatherModalComponent", void 0);
    __decorate([
        ViewChild('leaveWorkshopWarningModal', { static: false })
    ], ConfigureViewTabComponent.prototype, "leaveWorkshopWarningModal", void 0);
    __decorate([
        ViewChild('configureViewTitleList', { static: false })
    ], ConfigureViewTabComponent.prototype, "configureViewTitleList", void 0);
    __decorate([
        ViewChild('configureViewTitleWindow', { static: false })
    ], ConfigureViewTabComponent.prototype, "configureViewTitleWindow", void 0);
    __decorate([
        Input()
    ], ConfigureViewTabComponent.prototype, "configureId", void 0);
    __decorate([
        Output()
    ], ConfigureViewTabComponent.prototype, "viewChanged", void 0);
    __decorate([
        Output()
    ], ConfigureViewTabComponent.prototype, "responseContentView", void 0);
    __decorate([
        Input()
    ], ConfigureViewTabComponent.prototype, "commandHandler", void 0);
    __decorate([
        HostListener('window:resize', [])
    ], ConfigureViewTabComponent.prototype, "moveConfigureViewTitleList", null);
    ConfigureViewTabComponent = __decorate([
        Component({
            selector: 'configure-view-tab',
            template: "<div class=\"design-view-tab\"> <nav class=\"diagram\"> <div class=\"diagram-div\"> <div class=\"view-tab-title\" #configureViewTitleWindow> <ul class=\"title-ul\" #configureViewTitleList [style.left.px]=\"configureViewTitleMoveDistance\"> <li *ngFor=\"let view of views\" (click)=\"selectView(view.id, view.type)\" [ngClass]=\"{'active': view.id === selectedViewId}\"> <i class=\"tabsIcon\" [ngClass]=\"getIconClass(view)\"></i> {{view.name}}{{view.modified?'*':''}} <button (click)=\"tryRemoveTabHandler(view)\" class=\"removeTabBtn\"></button> </li> </ul> </div> <div *ngFor=\"let view of views\" class=\"view-tab-content\" [style.height]=\"view.id === selectedViewId ? 'auto': '0'\"> <configure-view [commandHandler]='commandHandler' [args]=\"getConfigureViewArg(view)\" (modifiedChange)=\"view.modified = $event ;\" (elementDoubleClicked)='elementDoubleClicked($event)' (responseViewTabActive)=\"responseViewTabActive()\"> </configure-view> </div> <div class=\"more-button\"> <button class=\"more\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"> <i class=\"fcloud-left\"></i> </button> <ul class=\"dropdown-menu\"> <li> <a href=\"javascript:;\" (click)=\"closeCurrentView()\">{{lc('CloseCurrentView')}}</a> </li> <li> <a href=\"javascript:;\" (click)=\"closeOtherViews()\">{{lc('CloseOtherViews')}}</a> </li> <li> <a href=\"javascript:;\" (click)=\"closeAllViews()\">{{lc('CloseAllViews')}}</a> </li> <li> <hr> </li> <li class=\"view-list\"> <div class=\"view-list-title\" *ngFor=\"let view of views\" (click)=\"selectView(view.id, view.type)\"> {{view.name}} </div> </li> </ul> </div> </div> </nav> </div> <numerical-display-setting-modal #numericalDisplaySettingModal [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"></numerical-display-setting-modal> <image-setting-modal #imageSettingModal [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"> </image-setting-modal> <text-setting-modal #textSettingModalComponent></text-setting-modal> <hyperlink-modal #hyperlinkModalComponent></hyperlink-modal> <switch-indicator-light-setting-modal #switchIndicatorLightSettingModal [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"></switch-indicator-light-setting-modal> <pipe-setting-modal #pipeSettingModalComponent></pipe-setting-modal> <meter-setting-modal #meterSettingModalComponent [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"> </meter-setting-modal> <bar-graph-setting-modal #barGraphSettingModal></bar-graph-setting-modal> <toggle-view-setting-modal #toggleViewSettingModal [currentConfigureViewId]=\"selectedViewId\" [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"></toggle-view-setting-modal> <character-setting-modal #characterDisplaySettingModal [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"> </character-setting-modal> <rectangle-setting-modal #rectangleSettingModal [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"> </rectangle-setting-modal> <ellipse-setting-modal #ellipseSettingModal [viewWidth]=\"selectViewWidth\" [viewHeight]=\"selectViewHeight\"> </ellipse-setting-modal> <sector-setting-modal #sectorSettingModal></sector-setting-modal> <date-time-setting-modal #dateTimeSettingModal></date-time-setting-modal> <weather-modal #weatherModalComponent></weather-modal> <app-leave-workshop-warning #leaveWorkshopWarningModal [name]=\"name\" [customWaringName]=\"customWaringName\" (onSave)=\"saveEvent()\" (onUnSave)=\"unSaveEvent()\"></app-leave-workshop-warning> ",
            styles: [".design-designer{ @titleBackground: #f4f4f4; @titleHeight: 28px; @titlePadding: 0 10px; ul.windowUl { padding: 0; list-style: none; } .screenTitle a { text-decoration: none; display: inline-block; height: 20px; cursor: pointer; width: 20px; background-image: url(\"/assets/common/images/configure/toolbar.png\"); } .levelSpacing { background-position: -40px -60px; } .levelSpacing:hover { background-position: 0px -60px; } .verticalSpacing { background-position: -100px -60px; } .verticalSpacing:hover { background-position: -60px -60px; } .aequilatus { background-position: -160px -60px; } .aequilatus:hover { background-position: -120px -60px; } .accordant { background-position: -220px -60px; } .accordant:hover { background-position: -180px -60px; } .large { background-position: -40px -80px; } .large:hover { background-position: 0px -80px; } .homochromy { background-position: -100px -80px; } .homochromy:hover { background-position: -60px -80px; } .topFloor { background-position: -160px -80px; } .topFloor:hover { background-position: -120px -80px; } .bottomFloor { background-position: -220px -80px; } .bottomFloor:hover { background-position: -180px -80px; } .upperFloor { background-position: -40px -100px; } .upperFloor:hover { background-position: 0px -100px; } .nextFloor { background-position: -100px -100px; } .nextFloor:hover { background-position: -60px -100px; } .top { background-position: 80px -80px; } .top:hover { background-position: 120px -80px; } .bottom { background-position: 20px -80px; } .bottom:hover { background-position: 60px -80px; } .prev { background-position: -40px -100px; } .prev:hover { background-position: 0px -100px; } .next { background-position: -100px -100px; } .next:hover { background-position: -60px -100px; } .contentBox { position: relative; overflow: hidden; width: 100%; } .windowsList { float: left; width: 220px; min-height: 500px; background: #f4f4f4; } .windowBox { border: solid 1px gray; } .padding { padding: 10px 0; } .floatRight { position: absolute; right: 0; display: inline-block; } .span { cursor: pointer; display: inline-block; height: 28px; width: 28px; } .itemList { position: relative; line-height: 24px; padding: 0 10px; } .itemList:hover { cursor: pointer; color: #000; background: #dae8ff; } .selected { background: #3695ff; color: #fff; } .configTitle { height: @titleHeight; padding: @titlePadding; background-color: @titleBackground; line-height: @titleHeight; color: #666; } @media (max-width:886px){ .diagram { top: 119px !important; } } @media (max-width:527px){ .diagram { top: 185px !important; } } .diagram { position: absolute; right: 0; top: 82px; left: 220px; bottom: 0; background-color: #bbb; .tab-content{ overflow: auto; } } .diagramContainer{ position: relative; } .contextMenu { z-index: 10001; position: absolute; left: 5px; background-color: #ffffff; display: none; font-size: 12px; font-family: sans-serif; font-weight: bold; box-shadow: 0 0 5px #666; } .contextMenu ul { list-style: none; top: 0; left: 0; margin: 0; padding: 0; } .contextMenu li a { position: relative; min-width: 60px; display: inline-block; padding: 6px; text-decoration: none; cursor: pointer; font-size: 12px; color: #666; font-weight: initial; } .contextMenu li:hover { background: #dae8ff; } .contextMenu li ul li { display: none; } .contextMenu li ul li a { position: relative; min-width: 60px; padding: 6px; text-decoration: none; cursor: pointer; } .contextMenu li:hover ul li { display: block; margin-left: 0px; margin-top: 0px; } } ",
                ".design-view-tab{.diagram-div { position: relative; width: 100%; height: 100%; overflow: hidden; .view-tab-title { width: 100%; overflow: hidden; background: #f4f4f4; height: 28px; position: relative; ul, li { margin: 0; padding: 0; list-style: none; } ul.title-ul, .title-ul li { height: 100%; } ul.title-ul { white-space: nowrap; position: absolute; left: 0; transition: left 0.5s ease-in-out; } .title-ul li { display: inline-block; cursor: pointer; line-height: 28px; padding: 0 5px } .removeTabBtn { width: 14px; height: 14px; border: none; top: 5px; right: 0; background: url(\"/assets/common/images/configure/toolbar.png\") -150px -158px; color: transparent; } .tabsIcon { display: inline-block; width: 14px; height: 16px; position: relative; top: 2px; background: url(\"/assets/common/images/configure/toolbar.png\") -123px -158px; } .pageTabs-default-web-icon { background-position: -94px -158px; } .pageTabs-default-app-icon { background-position: -122px -158px; } .pageTabs-startup-web-icon { background-position: -80px -158px; } .pageTabs-startup-app-icon { background-position: -108px -158px; } .pageTabs-thumbnail-icon { background-position: -136px -158px; } .title-ul li:hover .removeTabBtn { background-position: -150px -158px; } .title-ul .title-ul li:hover .removeTabBtn:hover { background-position: -164px -158px; } .title-ul li:hover { background: #eee; } .title-ul li.active { background: #ddd; } } .view-tab-content { overflow: hidden; } } .popview-thumbnail-icon.tabsIcon { background: url('/assets/common/images/configure/toolbar.png'); background-position: -80px -174px; } .more-button { position: absolute; right: 0; top: 0; z-index: 999; button { background: #f4f4f4; border: 0; width: 28px; height: 28px; cursor: pointer; } .dropdown-menu { right: 0; border-radius: 0; padding: 0; hr { margin: 5px 0; } } .dropdown-menu>li>a { font-size: 12px; padding: 2px 5px; color: #666; line-height: 24px; } .dropdown-menu>li>a:hover { background: #dae8ff; } .view-list-title { width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding: 2px 5px; cursor: pointer; font-size: 12px; line-height: 24px; color: #666; } .view-list-title:hover { background: #dae8ff; } .more { transform: rotateZ(-90deg); .fcloud-left { margin-top: 0; } .fcloud-left:before { color: #A0A2AD; } } .view-list { max-height: 200px; overflow: hidden auto; } } }"],
        })
    ], ConfigureViewTabComponent);
    return ConfigureViewTabComponent;
}(ConfigureComponentBase));
export { ConfigureViewTabComponent };
